export function setDate(date) {
  return {
    type: 'SET_DATE',
    date: date
  };
}


// WEBPACK FOOTER //
// ./src/actions/calendarActions.js